import axios from 'axios';
import config, { loadConfig } from '../Config';

const getApiAccountsUrl = () => `${(config.apiBaseUrl || '').replace(/\/$/, '')}/Accounts`;
const getUserMenuPermissionsUrl = () => `${(config.apiBaseUrl || '').replace(/\/$/, '')}/Users`;

export const getAuthToken = () =>
  localStorage.getItem("accessToken") ||
  localStorage.getItem("auth") ||
  localStorage.getItem("authToken") ||
  null;

export const getAuthHeaders = (extraHeaders = {}) => {
  const token = getAuthToken();
  if (!token) return { ...extraHeaders };
  return {
    ...extraHeaders,
    Authorization: `Bearer ${token}`,
  };
};

export const getMenuPermissions = () => {
  try {
    const raw = localStorage.getItem("menuPermissions");
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
};

export const hasMenuPerm = (key) => {
  const value = getMenuPermissions()?.[key];
  if (value === true || value === 1) return true;
  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();
    return normalized === "true" || normalized === "1";
  }
  return false;
};

export const canShowQuoteDelete = () => {
  const role = (localStorage.getItem("userRole") || "").toString().toLowerCase();
  if (role !== "user") return true;

  const module = (localStorage.getItem("activeModule") || "QUOTE").toUpperCase();
  if (module === "SALES") return hasMenuPerm("issaleS_DELETE");
  if (module === "TRAVELER") return hasMenuPerm("istraveL_DELETE");
  return hasMenuPerm("isquotE_DELETE");
};

export const canShowBackflushDelete = () => {
  const perms = getMenuPermissions();
  for (const [key, value] of Object.entries(perms || {})) {
    if (key.replace(/[_-]/g, "").toLowerCase() !== "isbackflushupdate") continue;
    if (value === true || value === 1) return true;
    if (typeof value === "string") {
      const normalized = value.trim().toLowerCase();
      return normalized === "true" || normalized === "1";
    }
    return false;
  }
  return false;
};

export const canModifySystemData = () => {
  if (hasMenuPerm("issysteM_MODIFY")) return true;
  const role = (localStorage.getItem("userRole") || "").toString().toLowerCase();
  return role !== "user";
};

export const loginUser = async (username, password) => {
  try {
    await loadConfig();
    const response = await axios.post(`${getApiAccountsUrl()}/login`, { username, password });
    return response.data;
  } catch (error) {
    const message = error?.response?.data || 'Login failed';
    throw new Error(message);
  }
};

const unwrapList = (payload) => {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.result)) return payload.result;
  if (Array.isArray(payload?.items)) return payload.items;
  if (Array.isArray(payload?.users)) return payload.users;
  if (Array.isArray(payload?.$values)) return payload.$values;
  if (Array.isArray(payload?.data?.$values)) return payload.data.$values;
  if (Array.isArray(payload?.result?.$values)) return payload.result.$values;
  return [];
};

export const getUserMenuPermissions = async () => {
  await loadConfig();
  const response = await axios.get(`${getUserMenuPermissionsUrl()}/GetAllUsersMenuDetails`, {
    headers: getAuthHeaders(),
  });
  return unwrapList(response.data);
};

export const updateUserMenuPermissions = async (userAccess) => {
  await loadConfig();
  const response = await axios.put(
    `${getUserMenuPermissionsUrl()}/UpdateUserMenuPermissions`,
    userAccess,
    { headers: getAuthHeaders({ "Content-Type": "application/json" }) }
  );
  return response.data;
};

export const getUserMenuDetails = async (userId) => {
  await loadConfig();
  if (!userId) return null;
  try {
    const response = await axios.get(`${getUserMenuPermissionsUrl()}/GetUserMenuDetails${userId}`, {
      headers: getAuthHeaders(),
    });
    return response.data || null;
  } catch (error) {
    if (error?.response?.status === 404) return null;
    throw error;
  }
};

export const saveUserMenuDetails = async (userId, payload) => {
  await loadConfig();
  const headers = getAuthHeaders({ "Content-Type": "application/json" });
  try {
    const response = await axios.put(
      `${getUserMenuPermissionsUrl()}/UpdateUserMenuDetails${userId}`,
      payload,
      { headers }
    );
    return response.data;
  } catch (error) {
    if (error?.response?.status !== 404) throw error;
    const response = await axios.post(
      `${getUserMenuPermissionsUrl()}/InsertUserMenuDetails`,
      payload,
      { headers }
    );
    return response.data;
  }
};

